<template>
  <div class="echartsBar-box">
    <div
      :ref="`echartsBar${echartsId}`"
      class="echartsBar"
    />
    <div
      class="empty"
      v-show="isEmpty"
    >
      暂无数据
    </div>
  </div>
</template>

<script>
import Echarts from 'echarts'
export default {
  props: {
    echartsId: {
      type: String,
      default: ''
    },
    dataList: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            z: 0,
            shadowStyle: {
              color: '#E2EDFF'
            }
          },
          formatter: '{b}：{c}'
        },
        grid: {
          left: '10',
          top: '30',
          right: '40',
          bottom: '30',
          containLabel: true
        },
        xAxis: {},
        yAxis: {},
        series: []
      }
    }
  },
  computed: {
    isEmpty() {
      return !(this.dataList.series && this.dataList.series[0] && this.dataList.series[0].data && this.dataList.series[0].data.length !== 0)
    }
  },
  mounted() {
    this.myChart = Echarts.init(this.$refs[`echartsBar${this.echartsId}`])
    this.drawBar()
  },
  methods: {
    drawBar() {
      if (this.dataList.grid) {
        this.option.grid = this.dataList.grid
      }
      this.option.xAxis = this.dataList.xAxisData
      this.option.yAxis = this.dataList.yAxisData
      this.option.series = this.dataList.series
      this.myChart.setOption(this.option, true)
    }
  },
  watch: {
    dataList: {
      handler(newVal) {
        this.drawBar()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.echartsBar-box {
  position: relative;
  height: 100%;
  .echartsBar {
    height: 100%;
  }
  .empty {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-10px, -6px);
    font-size: 12px;
    color: #999;
  }
}
</style>
